import { jsx as _jsx } from "react/jsx-runtime";
import Link from 'react-router/lib/Link';
import { WaitingListLabel } from './WaitingListLabel';
export var WaitingListLinkOnly = function (_a) {
    var customersWaiting = _a.customersWaiting, date = _a.date, className = _a.className;
    return (_jsx(Link, { to: "/waiting-list?date=".concat(date), className: className, children: _jsx(WaitingListLabel, { customersWaiting: customersWaiting }) }));
};
WaitingListLinkOnly.defaultProps = {
    customersWaiting: 0,
    date: '',
    className: '',
};
